module.exports = __webpack_public_path__ + "static/media/goldBag.44459158.png";